export default __webpack_public_path__ + "static/media/V340_RoHS.f693a0f8.pdf";